/*
* Copyright (c) 2006-2007 Erin Catto http://www.gphysics.com
*
* This software is provided 'as-is', without any express or implied
* warranty.  In no event will the authors be held liable for any damages
* arising from the use of this software.
* Permission is granted to anyone to use this software for any purpose,
* including commercial applications, and to alter it and redistribute it
* freely, subject to the following restrictions:
* 1. The origin of this software must not be misrepresented; you must not
* claim that you wrote the original software. If you use this software
* in a product, an acknowledgment in the product documentation would be
* appreciated but is not required.
* 2. Altered source versions must be plainly marked as such, and must not be
* misrepresented as being the original software.
* 3. This notice may not be removed or altered from any source distribution.
*/
import { b2Math, b2Vec2 } from '../../Common/Math';
/// This holds the mass data computed for a shape.
var b2MassData = /** @class */ (function () {
    function b2MassData() {
        /// The mass of the shape, usually in kilograms.
        this.mass = 0.0;
        /// The position of the shape's centroid relative to the shape's origin.
        this.center = new b2Vec2(0, 0);
        /// The rotational inertia of the shape.
        this.I = 0.0;
    }
    b2MassData.Add = function () {
        var masses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            masses[_i] = arguments[_i];
        }
        var finalMass = new b2MassData();
        for (var _a = 0, masses_1 = masses; _a < masses_1.length; _a++) {
            var massData = masses_1[_a];
            finalMass.mass += massData.mass;
        }
        //b2Settings.b2Assert(finalMass.mass>=0);
        if (Math.abs(finalMass.mass) > Number.MIN_VALUE) {
            for (var _b = 0, masses_2 = masses; _b < masses_2.length; _b++) {
                var massData = masses_2[_b];
                finalMass.center.x += massData.mass * massData.center.x;
                finalMass.center.y += massData.mass * massData.center.y;
            }
            finalMass.center.x /= finalMass.mass;
            finalMass.center.y /= finalMass.mass;
            for (var _c = 0, masses_3 = masses; _c < masses_3.length; _c++) {
                var massData = masses_3[_c];
                finalMass.I += massData.I;
                var r = b2Math.SubtractVV(massData.center, finalMass.center);
                finalMass.I += massData.mass * b2Math.b2Dot(r, r);
            }
        }
        return finalMass;
    };
    b2MassData.prototype.Set = function (massData) {
        this.mass = massData.mass;
        this.center.x = massData.center.x;
        this.center.y = massData.center.y;
        this.I = massData.I;
    };
    return b2MassData;
}());
export { b2MassData };
